// extracted by mini-css-extract-plugin
export default {"headerTitleColumn":"AdminUserManagement_headerTitleColumn_qysVV","tableName":"AdminUserManagement_tableName_bz2cD","spinAround":"AdminUserManagement_spinAround_tBeZM"};